import { SETTINGS_KEY, SIDEBAR_PARENTS } from '@app/constants/navigation';
import { navigation } from '@app/data';

const findItemByKey = (
  items: typeof navigation,
  keyToFind: string
): (typeof navigation)[number] | undefined => {
  for (const item of items) {
    if ('key' in item && item.key === keyToFind) return item;
    if ('children' in item && Array.isArray(item.children)) {
      const found = findItemByKey(item.children, keyToFind);
      if (found) return found;
    }
  }
  return undefined;
};

export const findSidebarParentKey = (pageKey: string) => {
  const matchedItem = findItemByKey(navigation, pageKey);
  const sidebarparentid = matchedItem?.sidebarparentid;

  if (
    matchedItem &&
    'key' in matchedItem &&
    matchedItem.key &&
    matchedItem.issidebaritem !== 'false' &&
    sidebarparentid === matchedItem.id
  ) {
    return matchedItem.key;
  }

  const navigationKey = SIDEBAR_PARENTS.find(
    ({ id }) => id === sidebarparentid
  )?.navigationKey;

  return navigationKey || SETTINGS_KEY;
};
